<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="17.525"
		height="17.34"
		viewBox="0 0 17.525 17.34"
	>
		<defs>
			<clipPath id="clip-path-HideSvg">
				<rect id="Rectangle_15235" data-name="Rectangle 15235" width="17.525" height="17.34" fill="none" />
			</clipPath>
		</defs>
		<g id="Group_45365" data-name="Group 45365" transform="translate(0 0)">
			<g id="Group_45365-2" data-name="Group 45365" transform="translate(0 0)" clip-path="url(#clip-path-HideSvg)">
				<path
					id="Path_32499"
					data-name="Path 32499"
					d="M14.415,6.563a.75.75,0,0,1-.1,0h-5.1a.721.721,0,0,1-.72-.721L8.5.75"
					transform="translate(1.59 0.759)"
					fill="none"
					stroke="#6b7786"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					id="Path_32500"
					data-name="Path 32500"
					d="M5.916,5.813a.75.75,0,0,1-.1,0H.72A.721.721,0,0,1,0,5.093L0,0"
					transform="translate(7.436 15.831) rotate(180)"
					fill="none"
					stroke="#6b7786"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'HideSvg',
};
</script>

<style scoped lang="scss"></style>
